import { EnumModuloDTONecessitaFirma } from '@framework/api-client/api/inquiries/schemas/enumModuloDTONecessitaFirma.ts';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { type StatoValidazione } from '@framework/api-client/api/inquiries-compile/schemas/statoValidazione.ts';
import { type DatiSessioneUtente } from '@framework/api-client/api/users/schemas/datiSessioneUtente.ts';
import { SubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/SubmissionModuleState.ts';
import { type IFrontOfficeModule } from '@framework/common-web/frontoffice/module/IFrontOfficeModule.ts';

export class SubmissionModuleLogic {
  static getState(module: IFrontOfficeModule): SubmissionModuleState {
    return module.stato ?? SubmissionModuleState.None;
  }

  /**
   * Controlliamo se il modulo è stato visitato
   */
  static isVisited(
    validationState: StatoValidazione | null | undefined,
  ): boolean {
    return validationState?.visitato ?? false;
  }

  /**
   * Controlliamo se il modulo è valido
   */
  static isValid(
    validationState: StatoValidazione | null | undefined,
  ): boolean {
    return validationState?.valido ?? false;
  }

  /**
   * Ritorna vero se la firma è necessaria per il modulo
   */
  static needSign(
    module: IFrontOfficeModule,
    submission: RichiestaDTO,
    user: DatiSessioneUtente | null | undefined,
  ) {
    // Controllo se la firma è richiesta dalla configurazione del modulo
    // TODO Gestire override domandaModulo (submissionModule.domandaModulo.necessitaFirma)
    if (module?.necessitaFirma === EnumModuloDTONecessitaFirma.NO) {
      return false;
    }

    // Controllo se la firma è richiesta solo per un Delegato
    if (
      module?.necessitaFirma === EnumModuloDTONecessitaFirma.SI_SE_NON_TITOLARE
    ) {
      // La firma è richiesta solo se l'utente loggato non è tra i titolari
      return !submission.datiTitolari?.some(
        t => t.idUtente === user?.utenteLoggato?.idUtente,
      );
    }

    return true;
  }
}
